import { createSlice, PayloadAction } from '@reduxjs/toolkit'

interface Song {
  trackid: string | number
  [key: string]: unknown
}

interface PlayHistoryState {
  songs: Song[]
}

const initialState: PlayHistoryState = {
  songs: [],
}

const playHistorySlice = createSlice({
  name: 'playHistory',
  initialState,
  reducers: {
    addSong: (state, action: PayloadAction<Song>) => {
      const song = action.payload
      if (state.songs.some((item) => item.trackid === song.trackid)) {
        return
      }
      state.songs.unshift(song)
    },
    removeSong: (state, action: PayloadAction<Song>) => {
      state.songs = state.songs.filter(
        (item) => item.trackid !== action.payload.trackid
      )
    },
    clearList: () => initialState,
    reset: () => initialState,
  },
})

export const playHistoryActions = playHistorySlice.actions
export const playHistoryReducer = playHistorySlice.reducer
export default playHistoryActions
